module.exports = __webpack_public_path__ + "img/logos_enes021.1320743f.png";